import couriers from './couriers'
import operator from './operator'
import holding from './holding'
import license from './license'
import security from './security'
import blackList from './black-list'
import gateway from './gateway'
import contract from './contract'
import shift from '../courier/shift'

export default {
  name: 'Courier',
  path: 'courier',
  meta: {
    label: 'company',
    auth: 'courier'
  },
  component: {
    name: 'Courier',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    couriers,
    operator,
    holding,
    license,
    security,
    gateway,
    blackList,
    contract,
    shift
  ]
}
